import { Entity } from '../../entity'
import { State } from '../../state/State.type'
import { randomId } from '../../util/rand'
import { SymmetryScriptOption } from './SymmetryScriptOption.type'

const MirrorTopToBottomOption: SymmetryScriptOption = {
  dname: 'Mirror Top To Bottom',
  run(prevState: State): State {
    const { height } = prevState
    const rng = { ...prevState.rng }
    const halfHeight = parseInt((height / 2) as unknown as string)
    const halfHeightStartsAt = height - halfHeight

    // remove all entities that will be copied over
    const ents = prevState.ents.filter((ent: Entity) => {
      if (ent.y >= halfHeightStartsAt) {
        return false
      }
      return true
    })
    ents.concat().forEach((ent: Entity) => {
      if (ent.y < halfHeight) {
        ents.push({
          ...ent,
          y: height - 1 - ent.y,
          id: randomId(ents, rng),
        })
      }
    })

    return {
      ...prevState,
      ents,
      rng,
    }
  },
}

export default MirrorTopToBottomOption
